<template>
	<div class="echarShow">
		<van-cell-group class="navShow">
			<van-row>
			<van-col :span="3" style='font-size:.6rem;position:relative;top:3px;'>
				<van-icon name="arrow-left" color="#fff" @click="back"/>
			</van-col>
			<van-col :span="18">统计分析</van-col>
			<van-col :span="2"></van-col>
			</van-row>
		</van-cell-group>
		<van-row class="elRow">
			<van-col class="elCol" :span="24" style="height:48.5%;" v-if='fromGc'>
				<div class="colBox">
					<van-cell title="危险作业一张图">
						<template #icon>
							<img src="../../assets/imgs/home/index/JCJS.png" />
						</template>
					</van-cell>
					<div class="colContent">
						<!-- <img :src="require('../../assets/images/staticMap.png')" alt="" width="100%" height="100%"> -->
						<bigPingMap style="height: 100%;" :highRiskPosition="highRiskPosition" ref="bigPingMap" @getMonitorIndex="getMonitorIndex"
						 @jumpToRiskPage="jumpToRiskPage"></bigPingMap>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24">
				<div class="colBox">
					<van-cell title="危险作业状态" value="查看更多" @click="jumpToPage(6)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYLB.png" />
						</template>
					</van-cell>
					<div class="colContent" style='display:flex;align-items: center;justify-content: center;position:relative;'>
						<chartSpe :defOptions="stateData" @echartsClick="jumpToPage(6)" />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24">
				<div class="colBox">
					<van-cell title="危险作业人员" value="查看更多" @click="jumpToPage(8)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYTS.png" />
						</template>
					</van-cell>
					<div class="colContent" style='position:relative;display: flex;align-items: center;justify-content: center;'>
						<annularChart :annularData="peopleData" :peoColor="true" :piePosition="['50%', '60%']" :pieRadius="['56%', '76%']" @itemClick="clickPeo" />
						<div class='text' style="top:46%;z-index:2;">
							<span class='titleOne' style='font-size: 20px;font-weight:bold;' @click="jumpToPage(8)">{{peopleNum}}</span><br>
							<span class='titleTwo' style='font-size: 14px;color: #bbb;'>人员总数</span>
						</div>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24">
				<div class="colBox">
					<van-cell title="危险作业类别占比" value="查看更多" @click="jumpToPage(9)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYJB.png" />
						</template>
					</van-cell>
					<div class="colContent" style='position:relative;display: flex;align-items: center;justify-content: center;'>
						<annularChart :annularData="workPerData" :piePosition="['50%', '60%']" :pieRadius="['56%', '76%']" @itemClick="jumpToPage(9)" />
						<div class='text' style="top:46%;z-index:2;">
							<span class='titleOne' style='font-size: 20px;font-weight:bold;' @click="jumpToPage(9)">{{workPerNum}}</span><br>
							<span class='titleTwo' style='font-size: 14px;color: #bbb;'>作业总数</span>
						</div>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24">
				<div class="colBox">
					<!-- <van-cell title="相关方作业" value="查看更多" @click="jumpToPage(4)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYLB.png" />
						</template>
					</van-cell> -->
					<div class="colHeader">
						<img src="../../assets/images/icon2.png" alt="">
						<span>相关方作业</span>
						<span style='font-size:16px;color:red;margin-left:5px;'>{{xgfNum}}</span>
						<!-- <span style='font-size:16px;color:red;' @click="jumpToPage(4)">{{xgfNum}}</span> -->
						<span class='more' @click="jumpToPage(4)">查看更多</span>
					</div>
					<div class="colContent">
						<chartSpe :defOptions="passData" @echartsClick="jumpToPage(4)" />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24">
				<div class="colBox">
					<van-cell title="相关方作业占比" value="查看更多" @click="jumpToPage(10)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYTS.png" />
						</template>
					</van-cell>
					<div class="colContent">
						<chartSpe :defOptions="passPerData" @echartsClick="jumpToPage(10)" />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-if='fromGc'>
				<div class="colBox">
					<van-cell title="工作单元占比" value="查看更多" @click="jumpToPage(11)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYJB.png" />
						</template>
					</van-cell>
					<div class="colContent" style='position:relative;display: flex;align-items: center;justify-content: center;'>
						<annularChart :annularData="unitData" :piePosition="['50%', '60%']" :pieRadius="['56%', '76%']"
							@itemClick="jumpToPage(11)" />
						<div class='text' style="top:46%;z-index:2;">
							<span class='titleOne' style='font-size: 20px;font-weight:bold;cursor: pointer;' @click="jumpToPage(11)">{{unitNum}}</span><br>
							<span class='titleTwo' style='font-size: 12px;color: #bbb;'>工作单元总数</span>
						</div>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-if='fromGc'>
				<div class="colBox">
					<van-cell title="作业单位占比" value="查看更多" @click="jumpToPage(12)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYLB.png" />
						</template>
					</van-cell>
					<div class="colContent" style='position:relative;display: flex;align-items: center;justify-content: center;'>
						<annularChart :annularData="zyunitData" :piePosition="['50%', '60%']" :pieRadius="['56%', '76%']"
							@itemClick="jumpToPage(12)" />
						<div class='text' style="top:46%;z-index:2;">
							<span class='titleOne' style='font-size: 20px;font-weight:bold;cursor: pointer;' @click="jumpToPage(12)">{{zyunitNum}}</span><br>
							<span class='titleTwo' style='font-size: 12px;color: #bbb;'>作业单位总数</span>
						</div>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" v-if='fromGc'>
				<div class="colBox">
					<van-cell title="申请单位占比" value="查看更多" @click="jumpToPage(13)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYTS.png" />
						</template>
					</van-cell>
					<div class="colContent" style='position:relative;display: flex;align-items: center;justify-content: center;'>
						<annularChart :annularData="squnitData" :piePosition="['50%', '60%']" :pieRadius="['56%', '76%']"
							@itemClick="jumpToPage(13)" />
						<div class='text' style="top:46%;z-index:2;">
							<span class='titleOne' style='font-size: 20px;font-weight:bold;cursor: pointer;' @click="jumpToPage(13)">{{squnitNum}}</span><br>
							<span class='titleTwo' style='font-size: 12px;color: #bbb;'>申请单位总数</span>
						</div>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" style="height:18rem;">
				<div class="colBox">
					<van-cell title="危险作业类别" value="查看更多" @click="jumpToPage(2)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYJB.png" />
						</template>
					</van-cell>
					<div class="colContent">
						<barChart1 :barData="workState" :descript="true" :legendState="true" @echartsClick="jumpToPage(2)" />
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24">
				<div class="colBox">
					<van-cell title="危险作业曲线" value="查看更多" @click="jumpToPage(3)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYLB.png" />
						</template>
					</van-cell>
					<div class="colContent">
						<div style="display:block;overflow:hidden;">
							<div class="check">
								<span class="checkItem checkActive" @click="checkState">日</span>
								<span class="checkItem" @click="checkState">月</span>
								<!-- <span class="checkItem" @click="checkState">季</span> -->
								<span class="checkItem" @click="checkState">年</span>
							</div>
						</div>

						<div style="width:100%;height:calc(100% - 20px)">
							<curveChart :curveData="workNumber" :descript="true" @echartsClick="jumpToPage(3)" />
						</div>
					</div>
				</div>
			</van-col>
			<!-- <van-col class="elCol" :span="24" v-if='fromZy || fromJt'>
				<div class="colBox">
				<div class="colHeader">
					<img src="../../assets/images/icon1.png" alt="">
					<span>危险作业状态曲线</span>
					<span class='more' @click="jumpToPage(6)">查看更多</span>
				</div>
				<div style='text-align:right;height:25px;line-height:25px;'>
					<div class="checkSta">
					<span class="checkItem checkActive" @click="checkStateSta">日</span>
						<span class="checkItem" @click="checkStateSta">月</span>
						<span class="checkItem" @click="checkStateSta">年</span>
					</div>
				</div>
				<div class="colContent" style='height:calc(100% - 55px)'>
					<curveChart :curveData="workSituation1" @echartsClick="echartsClickSta" :descript="true" :legendSel='true'/>
				</div>
				</div>
			</van-col> -->
			<van-col class="elCol" :span="24" v-if='fromZy || fromJt'>
				<div class="colBox">
				<div class="colHeader">
					<img src="../../assets/images/icon2.png" alt="">
					<span>危险作业类别曲线</span>
					<span class='more' @click="jumpToPage(9)">查看更多</span>
				</div>
				<div style='text-align:right;height:25px;line-height:25px;'>
					<div class="checkLb">
					<span class="checkItem checkActive" @click="checkStateLb">日</span>
						<span class="checkItem" @click="checkStateLb">月</span>
						<span class="checkItem" @click="checkStateLb">年</span>
					</div>
				</div>
				<div class="colContent" style='height:calc(100% - 55px)'>
					<curveChart :curveData="lbChartData" @echartsClick="jumpToPage(9)" :descript="true" :legendSel='true'/>
				</div>
				</div>
			</van-col>
			<van-col class="elCol elColCharts" :span="24" style='height:800px;' v-if='fromZy || fromJt'>
				<div class="colBox">
				<div class="colHeader">
					<img src="../../assets/images/icon3.png" alt="">
					<span v-if='fromZy'>基层工厂危险作业统计</span>
					<span v-if='fromJt'>专业化公司危险作业统计</span>
					<span class='more' @click="jumpToPage(7)">查看更多</span>
				</div>
				<div class="colContent">
					<barChart1 :barData="comData" @echartsClick='jumpToPage(7)' :descript="true" :legendState='true' />
				</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" style="height:20%;" v-if='fromGc'>
				<div class="colBox">
					<van-cell title="相关方管理">
						<template #icon>
							<img src="../../assets/imgs/home/index/XGFGL.png" />
						</template>
					</van-cell>
					<div class="colContent">
						<div class="xgfContent">
							<div class="xgf" @click="jumpToIndex">
								<img src="../../assets/images/management/XGF-icon1.png" />
								<p>单位：<span>{{departnum}}</span></p>
							</div>
							<div class="xgf" @click="jumpToXgfUser">
								<img src="../../assets/images/management/XGF-icon2.png" />
								<p>人员：<span>{{usernum}}</span></p>
							</div>
						</div>
					</div>
				</div>
			</van-col>
			<van-col class="elCol" :span="24" style="height: auto">
				<div class="colBox">
					<van-cell title="资料库" value="查看更多" @click="jumpToDirectory(centerText)">
						<template #icon>
							<img src="../../assets/imgs/home/index/WXZYJB.png" />
						</template>
					</van-cell>
				</div>
			</van-col>
		</van-row>
	</div>
</template>

<script>
	import bigPingMap from "@/components/gis/bigPingMap";
	import chartSpe from "../echarts/chartSpe";
	import annularChart from "../echarts/annularChart";
	import barChart1 from '../echarts/barChart1'
	import curveChart from '../echarts/curveChart'
	export default {
		name:'echarShow',
		data() {
			return {
				cyllx:sessionStorage.getItem("rootDept"),
				centerText: this.$route.params.name,
				fromGc:false,//是否是基层工厂的统计图
				fromZy:false,//是否是专业化公司的统计图
				fromJt:false,//是否是集团的统计图
				//地图
				highRiskPosition: [{
					lon: 117.60448,
					lat: 32.99656
				}, {
					lon: 117.60548,
					lat: 32.99656
				}, {
					lon: 117.60648,
					lat: 32.99656
				}],
				stateData: {
					tooltip: {
						show: true,
						trigger: 'item', //提示框触发类型，item数据项图形触发，主要应用于无类目轴的图表（散点图、饼形图等）
						formatter: "{b}: {c} ({d}%)"
					},
					color: ['#ff0000','#619aff','#ffd614','#0fc','#85d67f','#ec52f6','#5bcdfc', '#80c269', '#009bee', '#fd8a6c',
						'#c03', '#0fc', '#f8b551', '#ec6941', '#76b1f9', '#80c269', '#009bee', '#fd8a6c', '#c03', '#0fc', '#f8b551',
						'#ec6941', '#76b1f9', '#80c269',
					], //调色盘颜色列表，默认情况下图例和饼形环图颜色使用
					legend: {
						itemWidth:20,
						textStyle: {
							color: '#333',
						},
						pageIconSize: 16,
						pageButtonItemGap: 14,
						type: 'scroll',
						selectedMode: true, //图例选择模式
						orient: "horizontal", //图例布局方式
						formatter(name) {

						},
						textStyle: {
							rich: {
								b: {
									fontSize: 14,
									color: '#598cff',
									fontWeight: 'bold'
								}
							}
						}
					},
					// 主要展示层的
					series: [{
						radius: ['50%', '80%'],
						center: ['50%', '60%'],
						type: 'pie',
						roseType: 'radius',
						label: {
							normal: {
								show: false,
							},
						},
						name: "危险作业状态",
						data: [{
							name: "作业审批",
							value: 10
						}, {
							name: "技术交底",
							value: 30
						}, {
							name: "作业进行",
							value: 15
						}, {
							name: "作业完成",
							value: 6
						}, {
							name: "作业异常",
							value: 6
						}, {
							name: "作业取消",
							value: 6
						}],
					}],
				},
				peopleData:{},
				peopleNum:0,
				workPerData:{},
				workPerNum:0,
				passData: {
					tooltip: {
						show: true,
						trigger: 'item', //提示框触发类型，item数据项图形触发，主要应用于无类目轴的图表（散点图、饼形图等）
						formatter: function(params, ticket, callback) { //第一个参数数据集、第二个参数是异步回调标志、第三个参数是异步回调
							return params.name + ": " + params.value + "%"; //系列名称：数据值
						}
					},
					color: ['#6ab1ff', '#85d67f', '#ffe076', '#ffc63c', '#76b1f9', '#f8b551', '#ec6941', '#80c269', '#009bee'], //调色盘颜色列表，默认情况下图例和饼形环图颜色使用
					legend: {
						orient: 'horizontal',
						//right: 30,
						//top: 'center',
						formatter(name) {
							if (name == '甲类') {
								return name + '  ' + '{b|' + 3 + '}'
							} else if (name == '丙类') {
								return name + '  ' + '{b|' + 2 + '}'
							} else if (name == '乙类') {
								return name + '  ' + '{b|' + 1 + '}'
							}
						},
						textStyle: {
							rich: {
								b: {
									fontSize: 14,
									color: '#598cff',
									fontWeight: 'bold'
								}
							}
						}
					},
					// 主要展示层的
					series: [{
							type: 'pie',
							radius: '72%',
							center: ['50%', '55%'],
							label: {
								formatter: '{b}{d}%',
								show: false,
								position: 'inner'
							},
							// name: "相关方作业",
							data: [{
								name: '甲类',
								value: 3
							}, {
								name: '乙类',
								value: 1
							}, {
								name: '丙类',
								value: 2
							}],
						},
						{
							name: '外边框',
							type: 'pie',
							clockWise: false, //顺时加载
							hoverAnimation: false, //鼠标移入变大
							radius: ['78.5%', '79%'],
							label: {
								normal: {
									show: false
								}
							},
							center: ['50%', '55%'],
							data: [{
								value: 9,
								name: '',
								itemStyle: {
									normal: {
										borderWidth: 2,
										borderColor: '#d9d9d9'
									}
								}
							}]
						},
					],
				},
				passPerData: {
					tooltip: {
						show: true,
						trigger: "item", //提示框触发类型，item数据项图形触发，主要应用于无类目轴的图表（散点图、饼形图等）
						formatter: function(params, ticket, callback) {
							//第一个参数数据集、第二个参数是异步回调标志、第三个参数是异步回调
							return params.name+" : "+params.value+" ("+params.percent+"%)"; //系列名称：数据值
						},
					},
					color: [
						"#6ab1ff",
						"#85d67f",
						"#ffe076",
						"#ffc63c",
						"#76b1f9",
						"#f8b551",
						"#ec6941",
						"#80c269",
						"#009bee",
					], //调色盘颜色列表，默认情况下图例和饼形环图颜色使用
					legend: {
						orient: "horizontal",
						// right: 30,
						// top: "center",
						formatter(name) {
							if (name == "相关方作业") {
								return name + "  " + "{b|" + 3 + "}";
							} else if (name == "企业作业") {
								return name + "  " + "{b|" + 2 + "}";
							}
						},
						textStyle: {
							rich: {
								b: {
									fontSize: 14,
									color: "#598cff",
									fontWeight: "bold",
								},
							},
						},
					},
					// 主要展示层的
					series: [{
							type: "pie",
							radius: "72%",
							center: ['50%', '55%'],
							label: {
								formatter: "{b}{d}%",
								show: false,
								position: "inner",
							},
							// name: "相关方作业",
							data: [{
									name: "相关方作业",
									value: 3,
								},
								{
									name: "企业作业",
									value: 1,
								}
							],
						},
						{
							name: "外边框",
							type: "pie",
							clockWise: false, //顺时加载
							hoverAnimation: false, //鼠标移入变大
							radius: ['78.5%', '79%'],
							label: {
								normal: {
									show: false,
								},
							},
							center: ['50%', '55%'],
							data: [{
								value: 9,
								name: "",
								itemStyle: {
									normal: {
										borderWidth: 2,
										borderColor: "#d9d9d9",
									},
								},
							}, ],
						},
					],
				},
				xgfNum:0,
				unitData:{},
				unitNum:0,
				zyunitData:{},
				zyunitNum:0,
				squnitData:{},
				squnitNum:0,
				/* 柱状图 */
				workState: {},
				/* 折线图 */
				workNumber: {
					危险作业数量: {},
					一般危险: {},
					较大危险: {},
					高度危险: {},
				},
				//单位数量
				departnum: '0',
				usernum: '0',
				workSituation1:{},
				lbChartData:{},
				comData:{},
        sqdw:''
			}
		},
		components:{
			bigPingMap,
			chartSpe,
			annularChart,
			barChart1,
			curveChart
		},
		created() {
			let _that  =this
      this.JJKGetRoot()
      if(this.$route.params.from == 'gc'){
				this.fromGc = true
				this.fromZy = false
				this.fromJt = false
				this.getUnitData() //工作单元
				this.getZyUnitData() //作业单位
				this.getSqUnitData() //申请单位
			}else if(this.$route.params.from == 'zy'){
				this.fromGc = false
				this.fromZy = true
				this.fromJt = false
				// this.getDangerWorkYearNum1("1") //状态曲线
				this.getComData() //基层工厂危险作业统计
				this.getLbNum(1) //类别曲线
			}else if(this.$route.params.from == 'jt'){
				this.fromGc = false
				this.fromZy = false
				this.fromJt = true
				// this.getDangerWorkYearNum1("1") //状态曲线
				this.getComData() //基层工厂危险作业统计
				this.getLbNum(1) //类别曲线
			}
		},
		mounted() {
			let _that = this
      this.JJKGetRoot()
			this.getQyMsg()
			this.gatStateData()
			this.getPeopleData()
			this.getWorkPerData()
			this.getInterData();
			this.getInterPerData();
			this.getDangerWorkStatusNum()
			this.getDangerWorkYearNum("selectPollingZxByDay", "日")
			this.getDepartNum();
			this.getDepartUserNum();

		},
		methods: {
      JJKGetRoot(){
        //2022-01-12:针对于家佳康加查询条件如果包含（管理员、作业所在、安全管理、作业主管、安全分管）权限则查询全部，如果不包含这些权限则只查询当前登录人所在申请单位
        if (sessionStorage.getItem("ZYHGSMZ") === '中粮家佳康'){
          let permission = sessionStorage.getItem("permission")
          if (permission) {
            let userAuth = JSON.parse(permission);
            if (userAuth['ZYZGBMSPR']||userAuth['ZYSZBMSHR']||userAuth['GDWXZYSPR']||userAuth['AQGLBMSHR']||userAuth['QY_ADMIN']) {
              this.sqdw = ''
            }else{
              let loginUser = JSON.parse(sessionStorage.getItem("loginUser"))
              this.sqdw = loginUser.departName
            }
          }else{
            let loginUser = JSON.parse(sessionStorage.getItem("loginUser"))
            this.sqdw = loginUser.departName
          }
        }
      },
			back() {
				this.$router.go(-1);
			},
			getMonitorIndex: function(f) {
				this.$router.push({
					name: 'sxtIndex',
					params: {
						url: f.getId()
					}
				});
			},
			//打开对应作业的视频页面
			jumpToRiskPage: function(f) {
			},
			//统计图点击查看更多的跳转
			jumpToPage(num) {
				var jcname = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				this.$router.push({
					name: 'dangerWorkSituation',
					params: {
						state: num,
						jcname: jcname,
					}
				})
			},
			//获取作业状态数据
			gatStateData() {
				let _that = this
				let obj = {}
				obj.ZYHGSMZ = sessionStorage.getItem('ZYHGSMZ')
				obj.GCMZ = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				obj.TODAYWORK = 'YES'
				obj.cyllx = this.cyllx
        obj.SQDW = this.sqdw
        this.$axios.post('/dform/index/getDangerWorkStatusJTNum', obj)
					.then((res) => {
						if (res.data.code) {
							let objData = res.data.data
							let arrData = []
							for (let k in objData) {
								let obj = {}
								obj.name = k
								obj.value = objData[k]
								arrData.push(obj)
							}
							this.stateData.series[0].data = arrData
							this.stateData.legend.formatter = function(name) {
								let value = ''
								let rows = objData
								for (let k in rows) {
									if (k == name) {
										value = rows[k]
									}
								}
								return name + '  ' + '{b|' + value + '}'
							}
						}
					})
			},
			//状态统计图穿刺事件
			stateClick(params) {
				var jcname = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				this.$router.push({
					name: 'dangerWorkSituation',
					params: {
						state: 6,
						stateName: params,
						jcname: jcname
					}
				})
			},
			/* 人员类型 饼状图 */
			getPeopleData() {
				let _that = this
				let obj = {}
				obj.ZYHGSMZ = sessionStorage.getItem('ZYHGSMZ')
				obj.GCMZ = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				obj.TODAYWORK = 'YES'
				this.$axios.get('/dform/index/getZyhgsAndGc?zyhgsmz='+obj.ZYHGSMZ+"&gcmz="+obj.GCMZ+"&toDay="+obj.TODAYWORK+"&cyllx="+this.cyllx+"&sqdw="+this.sqdw)
					.then((res) => {
						if (res.data.code) {
							_that.peopleData = res.data.data
							let num = 0
							for (let k in _that.peopleData) {
								num += _that.peopleData[k]
							}
							_that.peopleNum = num
						}
					})
			},
			clickPeo(params) {
				// var jcname = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				this.$router.push({
					name: 'dangerWorkSituation',
					params: {
						state: 8
					}
				})
			},
			/* 作业类别占比饼状图 */
			getWorkPerData() {
				let _that = this
				let obj = {}
				obj.GCMZ = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				obj.ZYHGSMZ = this.$route.params.ZYHGSMZ || sessionStorage.getItem('ZYHGSMZ')
				obj.TODAYWORK = 'YES'
				this.$axios.get('/dform/index/getZylbCirclePicture?zyhgsmz='+obj.ZYHGSMZ+"&gcmz="+obj.GCMZ+"&today="+obj.TODAYWORK+"&cyllx="+this.cyllx+"&sqdw="+this.sqdw)
					.then((res) => {
						if (res.data.code) {
							_that.workPerData = res.data.data
							let num = 0
							for(let k in _that.workPerData){
								num+=_that.workPerData[k]
							}
							_that.workPerNum = num
						}

						// if (res.data.code) {
						// 	_that.workPerData = res.data.data
						// 	let num = 0
						// 	for (let k in _that.workPerData) {
						// 		num += _that.workPerData[k]
						// 	}
						// 	_that.workPerNum = num
						// }
					})
			},
			//作业类别占比穿刺
			echartsClickPer(params){
				this.$router.push({name:'dangerWorkSituation',params:{state:9,lbName:params.name}})
			},
			//获取相关方数据
			getInterData() {
				let _that = this
				let obj = {}
				this.qyName = sessionStorage.getItem('GCMZ') || ''
				obj.GCMZ = this.qyName
				obj.ZYHGSMZ = sessionStorage.getItem('ZYHGSMZ') || ''
				obj.TODAYWORK = 'YES'
				obj.XGFZYKIND = 'XGFZY'
				obj.cyllx = this.cyllx
        obj.SQDW = this.sqdw
        this.$axios.post('/dform/index/getDangerWorkXGFNum', obj)
					.then((res) => {
						if (res.data.code) {
							let objData = res.data.data
							_that.xgfNum = res.data.data['甲类'] + res.data.data['乙类'] + res.data.data['丙类']
							let arrData = []
							for (let k in objData) {
								let obj = {}
								obj.name = k
								obj.value = objData[k]
								arrData.push(obj)
							}
							this.passData.series[0].data = arrData
							this.passData.legend.formatter = function(name) {
								let value = ''
								let rows = objData
								for (let k in rows) {
									if (k == name) {
										value = rows[k]
									}
								}
								return name + '  ' + '{b|' + value + '}'
							}
						}
					})
			},
			//获取相关方作业占比数据
			getInterPerData() {
				let _that = this
				let obj = {}
				obj.GCMZ = sessionStorage.getItem('GCMZ')
				obj.ZYHGSMZ = sessionStorage.getItem('ZYHGSMZ')
				this.$axios.get("/dform/index/getXgfzyCirclePicture?zyhgsmz="+obj.ZYHGSMZ+"&gcmz="+obj.GCMZ+"&today=YES"+"&cyllx="+this.cyllx+"&sqdw="+this.sqdw)
					.then((res) => {
						if (res.data.code) {
							let objData = res.data.data;
								let arrData = [];
								for (let k in objData) {
									let obj = {};
									obj.name = k;
									obj.value = objData[k];
									arrData.push(obj);
								}
								this.passPerData.series[0].data = arrData;
								this.passPerData.legend.formatter = function(name) {
									let value = "";
									let rows = objData;
									for (let k in rows) {
										if (k == name) {
											value = rows[k];
										}
									}
									return name + "  " + "{b|" + value + "}";
								};
						}
					})
			},
			//相关方作业占比穿刺
			echartsClickXgf(params){
				this.$router.push({name:'dangerWorkSituation',params:{state:10,ZYLX:params}})
			},
			/* 工作单元饼状图 */
			getUnitData() {
				let _that = this
				let obj = {}
				obj.GCMZ = sessionStorage.getItem("GCMZ");
				obj.ZYHGSMZ = sessionStorage.getItem('ZYHGSMZ')
				obj.TODAYWORK = "YES";
				this.$axios.get('/dform/index/getZydyCirclePicture?zyhgsmz='+obj.ZYHGSMZ+"&gcmz="+obj.GCMZ+"&today="+obj.TODAYWORK+"&cyllx="+this.cyllx+"&sqdw="+this.sqdw)
					.then((res) => {
						if (res.data.code) {
							_that.unitData = res.data.data
						let num = 0
							for (let k in _that.unitData) {
								num += _that.unitData[k]
							}
							_that.unitNum = num
						}
					})
			},
			/* 作业单位饼状图 */
			getZyUnitData() {
				let _that = this
				let obj = {}
				obj.GCMZ = sessionStorage.getItem("GCMZ");
				obj.ZYHGSMZ = sessionStorage.getItem("ZYHGSMZ");
				obj.TODAYWORK = "YES";
				obj.cyllx = this.cyllx
        obj.SQDW = this.sqdw
        this.$axios.post('/dform/index/getZydwCirclePicture',obj)
					.then((res) => {
					if(res.data.code){
						if(!Object.keys(res.data.data).length){
							_that.zyunitData = {'作业单位':0}
						}else{
							_that.zyunitData = res.data.data;
						}
						let num = 0
							for (let k in _that.zyunitData) {
								num += _that.zyunitData[k]
							}
							_that.zyunitNum = num
					}
				})
			},
			//作业单位占比穿刺
			echartsClickZyUnit(params){
				this.$router.push({name:'dangerWorkSituation',params:{state:12,zyUnitName:params.name}})
			},
			/* 申请单位饼状图 */
			getSqUnitData() {
				let _that = this
				let obj = {}
				obj.GCMZ = sessionStorage.getItem("GCMZ");
				obj.ZYHGSMZ = sessionStorage.getItem("ZYHGSMZ");
				obj.TODAYWORK = "YES";
				obj.cyllx = this.cyllx
        obj.SQDW = this.sqdw
        this.$axios.post('/dform/index/getSqdwCirclePicture',obj)
					.then((res) => {
					if(res.data.code){
						if(!Object.keys(res.data.data).length){
							_that.squnitData = {'申请单位':0}
						}else{
							_that.squnitData = res.data.data;
						}
						let num = 0
							for (let k in _that.squnitData) {
								num += _that.squnitData[k]
							}
							_that.squnitNum = num
					}
				})
			},
			//申请单位占比穿刺
			echartsClickSqUnit(params){
				this.$router.push({name:'dangerWorkSituation',params:{state:13,sqUnitName:params.name}})
			},
			/* 获取危险作业状态数量 柱状图 */
			getDangerWorkStatusNum() {
				let _that = this
				let obj = {}
				obj.ZYHGSMZ = sessionStorage.getItem('ZYHGSMZ')
				obj.GCMZ = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				obj.TODAYWORK = 'YES'
				obj.TYPE= 'YES'
				obj.cyllx = this.cyllx
        obj.SQDW = this.sqdw
        this.$axios.post('/dform/index/getDangerWorkStatusNum', obj)
					.then((res) => {
						if (res.data.code) {
							_that.workState = res.data.data
						}
					})
			},
			workLB(params) {
				var jcname = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				this.$router.push({
					name: 'dangerWorkSituation',
					params: {
						state: 2,
						jcname: jcname,
						ZYLB: params
					}
				})
			},
			checkState(params) {
				/* 获取未被选中 */
				if (params.target.className.indexOf("checkActive") == -1) {
					// 事例 移除 p 具有类`special`的 special 类
					document.querySelector('.check span.checkItem.checkActive').classList.toggle('checkActive')
					params.target.setAttribute("class", 'checkItem checkActive');
					if (params.target.innerText == '月') {
						this.chartState = 2
						this.getDangerWorkYearNum("selectPollingZxByMonth", "月")
					} else if (params.target.innerText == '日') {
						this.chartState = 1
						this.getDangerWorkYearNum("selectPollingZxByDay", "日")
					} else if (params.target.innerText == '年') {
						this.chartState = 4
						this.getDangerWorkYearNum("selectPollingZxByYear", "年")
					} else if (params.target.innerText == '季') {
						this.chartState = 3
						this.getDangerWorkYearNum('4')
					}
				}
			},
			/* 折线图 */
			getDangerWorkYearNum(url, type) {
				let _that = this
				let obj = {}
				obj.companyName = sessionStorage.getItem('ZYHGSMZ')
				obj.qyName = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				obj.cyllx = this.cyllx
				obj.serchTime = '';
        obj.sqdw = this.sqdw
        this.$axios.post("/dform/workPolling/" + url, obj)
					.then((res) => {
						if (res.data.code) {
							_that.workNumber["危险作业数量"] = res.data.data.sum;
							_that.workNumber["高度危险"] = res.data.data.gaodumap;
							_that.workNumber["较大危险"] = res.data.data.jiaodamap;
							_that.workNumber["一般危险"] = res.data.data.yibanmap;
						}
					})
			},
			workTS(params) {
				var jcname = this.$route.params.GCMZ || sessionStorage.getItem('GCMZ')
				let serchTime = params.name.substring(
					0,
					params.name.length - 1
					);
				this.$router.push({
					name: 'dangerWorkSituation',
					params: {
						state: 3,
						jcname: jcname,
						serchTime: serchTime
					}
				})
			},
			jumpToIndex() {
				let qyName = sessionStorage.getItem('GCMZ')
				let arr = this.$store.state.qyInfo;
				let result
				if(arr){
					result = arr.find(item =>{
					return item.qyname == qyName
					});
				}
				if (result && result.companyIp) {
          if (sessionStorage.getItem("ZYHGSMZ") === '中粮糖业' && sessionStorage.getItem("loginFlag") == 6) {
            sessionStorage.setItem("baseURLSpe", 'http://safety1.cofcotunhe.com/api');
          } else {
            sessionStorage.setItem("baseURLSpe", result.companyIp);
          }
				}else{
					sessionStorage.setItem("baseURLSpe", 'http://117.14.55.74:17703/api');
				}
				this.$router.push({
					name: 'unitList'
				});
			},
			getDepartNum() {
				let qyguid = sessionStorage.getItem("qyGuid");
				let unitObj = sessionStorage.getItem("relatedUnitObj");
				if (unitObj == null) {
					unitObj = "{}";
				}
				let relatedUnitObj = JSON.parse(unitObj);
				relatedUnitObj.qyId = qyguid;
				this.$axios
					.post(
						"/safe/tbQybaseinfoRelated/listPageRelated", {
							orgCode: relatedUnitObj.orgCode,
							qyId: sessionStorage.getItem("qyGuid"),
							blacklist: 0, //黑名单 0否
							limit: 10,
							page: 1,
						}, {
							headers: {
								"Content-Type": "application/json",
							},
							showLoading: true,
						}
					)
					.then((res) => {
						if (res.data.code == 1) {
							this.departnum = res.data.data.total; // 赋值 总条数
						}
					});
			},
			//根据名称获取信息
			getQyMsg(){
				this.$axios.get("/user/qy/getQyByName?name=" + sessionStorage.getItem('GCMZ'), {}).then(res => {
					//this.GMID= res.data.data.qyguid
					this.latitude=res.data.data.latitude
					this.longitude=res.data.data.longitude
					this.getDepartNum();
					this.getDepartUserNum();
				});
			},
			jumpToXgfUser() {
				let qyName = sessionStorage.getItem('GCMZ')
				let arr = this.$store.state.qyInfo
				let result
				if(arr){
					result = arr.find(item =>{
						return item.qyname == qyName
					});
				}
				if(result && result.companyIp){
					sessionStorage.setItem('baseURLSpe',result.companyIp)
				}else{
					sessionStorage.setItem('baseURLSpe','http://117.14.55.74:17703/api')
				}
				this.$router.push({
					name: 'unitPersonnelAll'
				});
			},
			//相关方人员
			getDepartUserNum() {
				let qyguid = sessionStorage.getItem("qyGuid");
				let unitObj = sessionStorage.getItem("relatedUnitObj");
				if (unitObj == null) {
					unitObj = "{}";
				}
				let relatedUnitObj = JSON.parse(unitObj);
				relatedUnitObj.qyId = qyguid;
				this.$axios
					.post(
						"/safe/seUserRelated/listPageRelatedUser", {
							qyId: qyguid,
							name: this.theName,
							limit: 10,
							page: 1,
						}, {
							headers: {
								"Content-Type": "application/json",
							},
							showLoading: true,
						}
					)
					.then((res) => {
						if (res.data.code == 1) {
							this.usernum = res.data.data.total; // 赋值 总条数
						}
					});

			},
			//跳到资料库显示页面
			jumpToDirectory(name) {
				this.$router.push({
					name: 'directory',
					params: {
						name: name,
					}
				})
			},

			getDangerWorkYearNum1(num){
				let _that  =this
				let obj = {stype:num}
				// obj.GCMZ = sessionStorage.getItem('GCMZ')
				obj.ZYHGSMZ = sessionStorage.getItem('ZYHGSMZ')
				obj.TODAYWORK = "YES";
				obj.cyllx = this.cyllx
				this.$axios.post("/dform/index/getDiffentWorkTypeNum",obj)
				.then((res) => {
				if(res.data.code){
					_that.workSituation1 = res.data.data;
				}
				})
			},
			checkStateSta(params){
				/* 获取未被选中 */
				if(params.target.className.indexOf("checkActive") == -1){
				// 事例 移除 p 具有类`special`的 special 类
				document.querySelector('.checkSta span.checkItem.checkActive').classList.toggle('checkActive')
				params.target.setAttribute("class",'checkItem checkActive');
				if (params.target.innerText == '月') {
					this.chartState = 2
								this.getDangerWorkYearNum1("2")
							} else if (params.target.innerText == '日') {
					this.chartState = 1
								this.getDangerWorkYearNum1("1")
							} else if (params.target.innerText == '年') {
					this.chartState = 3
								this.getDangerWorkYearNum1("3")
							}
				}
			},
			echartsClickSta(params){
				let serchTime = params.name;
				this.$router.push({name:'dangerWorkSituation',params:{state:6,serchTime:serchTime}})
			},
			getLbNum(num){
				let _that  =this
				let obj = {stype:num}
				// obj.GCMZ = sessionStorage.getItem('GCMZ')
				obj.ZYHGSMZ = sessionStorage.getItem('ZYHGSMZ')
				obj.cyllx = this.cyllx
				this.$axios.get("/dform/index/getZylbLinePicture?zyhgsmz=" +
					obj.ZYHGSMZ +
					"&gcmz=&searchType=" +
					num+"&cyllx="+this.cyllx
				)
				.then((res) => {
				if(res.data.code){
					let obj = res.data.data;
					let data = {};
					for (let key in obj) {
					_that.$set(data, key, obj[key]);
					}
					_that.lbChartData = data;
				}
				})
			},
			checkStateLb(params){
				/* 获取未被选中 */
				if(params.target.className.indexOf("checkActive") == -1){
				// 事例 移除 p 具有类`special`的 special 类
				document.querySelector('.checkLb span.checkItem.checkActive').classList.toggle('checkActive')
				params.target.setAttribute("class",'checkItem checkActive');
				if (params.target.innerText == '月') {
					this.chartState = 2
								this.getLbNum("2")
							} else if (params.target.innerText == '日') {
					this.chartState = 1
								this.getLbNum("1")
							} else if (params.target.innerText == '年') {
					this.chartState = 3
								this.getLbNum("3")
							}
				}
			},
			echartsClickLb(params){
				let serchTime = params.name;
				this.$router.push({name:'dangerWorkSituation',params:{state:9,serchTime:serchTime}})
			},
			//获取专业化公司作业统计
			getComData(){
				let _that  =this
				let obj = {}
				obj.TODAYWORK = 'YES'
				// obj.GCMZ = sessionStorage.getItem('GCMZ')
				obj.ZYHGSMZ = sessionStorage.getItem('ZYHGSMZ')
				obj.cyllx = this.cyllx
        if (this.fromZy){
          obj.GC = 'yes'
        }
				this.$axios.post('/dform/index/getDangerWorkSumNum',obj)
				.then((res) => {
				if(res.data.code){
					this.comData = res.data.data
					let facHei = ''
					let facSum = Object.keys(res.data.data['数量']).length
					if(facSum >= 0 && facSum < 5){
					facHei = '42%'
					}else if(facSum >= 5 && facSum < 10){
					facHei = '84%'
					}else if(facSum >= 10 && facSum < 15){
					facHei = '126%'
					}else if(facSum >= 15 && facSum < 20){
					facHei = '168%'
					}else{
					facHei = '210%'
					}
					document.getElementsByClassName('elColCharts')[0].style.height=facHei
				}
				})
			},
		},
	}
</script>

<style scoped lang="less">
	.facTitle{
		font-size:15px;
		color:red;
		text-decoration: underline;
	}
	.eahartShow {
		height: calc(100% - 1.25rem) !important;
		overflow-y: auto;
		width: 100%;
		background-color: #e1eef6;
	}

	.elRow {
		height: 100%;
		width: 100%;
		overflow: auto;
	}
	.elCol {
		height: 42.5%;
		margin-bottom: 5px;
	}
	.colBox {
		background: #fff;
		height: 100%;
		padding: 10px;

		.van-cell {
			padding: 0;

			.van-cell__title {
				font-size: 15px;
				line-height: 30px;
			}

			img {
				width: 25px;
				height: 25px;
				margin-right: 8px;
				margin-top: 3px;
			}

			.van-cell__value {
				span {
					font-size: 12px;
					color: #434343;
					margin-right: 10px;
				}
			}
		}
	}
	.van-cell::after {
		border: none;
	}
	.colContent {
		height: calc(100% - 30px);
		padding-top: 10px;
	}
	.text{
	  position: absolute;
	  text-align: center;
	}
	.check {
		float: right;
		display: inline-block;
		// width: 2.2rem;
		height: 0.5rem;
		line-height: 0.5rem;
		border: 1px solid #eee;
	}

	.checkItem {
		width: 0.5rem;
		text-align: center;
		display: inline-block;
		cursor: pointer;
	}

	.checkActive {
		background: #f97475;
		color: #fff;
	}
	.xgfContent {
		width: 100%;
		height: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-content: space-between;

		.xgf {
			width: 49%;
			height: 100%;
			background: #f1f7ff;
			border-radius: 4px;
			font-size: 1vw;
			font-weight: bold;
			color: #333;
			display: flex;
			align-items: center;

			img {
				width: 27%;
				margin: 0px 10%;
			}

			p {
				margin-bottom: 0;
				font-size: 16px;
				font-weight: normal;
			}

			span {
				color: #74aefb;
				font-weight: bold;
				cursor: pointer;
			}
		}

		.xgf:nth-child(2) {
			background: #fff9eb;

			span {
				color: #ffc63c;
			}
		}

		.xgf:nth-child(3) {
			background: #fef4ec;

			span {
				color: #f19149;
			}
		}

		.xgf:nth-child(4) {
			background: #eefbf7;
		}
	}
	.colHeader{
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
    position: relative;
  }
  .elColSpe .colHeader{
    border-bottom: 1px solid #f2f2f2;
    padding-bottom: 5px;
    height: 35px;
    line-height: 35px;
  }
  .elColSpe .colHeader > div{
    display:flex;
    align-items: center;
  }
  .colHeader img{
    width: 25px;
    height: auto;
    margin-right: 8px;
  }
  .colHeader .more{
    font-size: 12px;
    position: absolute;
    right: 10px;
  }
  .elColSpe{
    height: auto;
    background: #fff;
    padding: 10px;
    text-align: center;
  }
  .elColSpe .num{
    font-size: 17px;
    font-weight: bold;
  }
  .num1{color: #55dbb1;}
  .num2{color: #eb6100;}
  .num3{color: #fec42c;}
  .num4{color: #74aefb;}
  .elColSpe span:nth-of-type(2){
    font-size: 13px;
  }
</style>
